module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Teddy-Bear-Web-1280.06aee750.png";